import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BackArrow from '../assets/images/Frame_18177.png';
import ForwadArrow from '../assets/images/Frame_18178.png';
import FiSearch from '../assets/images/fi_search.png';
import FiChevronsRight from '../assets/images/fi_chevrons-right.png';
import axios from 'axios';
import axiosInstance from '../api/axiosInstance';

const ABHA_API_URL = (process.env.REACT_APP_ABHA_API_URL || 'http://52.66.254.50:9797').replace(/\/$/, '');

const RegistrationWithAdhar = () => {
    const navigate = useNavigate();
    const [inputValue, setInputValue] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [otpInput, setOtpInput] = useState(['', '', '', '', '', '']);
    const [error, setError] = useState('');
    const [mobileError, setMobileError] = useState('');
    const [otpError, setOtpError] = useState('');
    const [loading, setLoading] = useState(false);
    const [seconds, setSeconds] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const [txnId, setTxnId] = useState('');
    const [step, setStep] = useState('aadhar'); // 'aadhar' or 'otp'
    const inputRefs = useRef([]);

    useEffect(() => {
        if (seconds > 0 && step === 'otp') {
            const timer = setInterval(() => {
                setSeconds(prev => prev - 1);
            }, 1000);
            return () => clearInterval(timer);
        } else if (seconds === 0) {
            setIsResendEnabled(true);
        }
    }, [seconds, step]);

    const formatAadhar = (value) => {
        const cleaned = value.replace(/\D/g, '').slice(0, 12);
        return cleaned.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
    };

    const handleAadharChange = (e) => {
        const value = e.target.value;
        if (/^[\d\s]*$/.test(value) && value.replace(/\s/g, '').length <= 12) {
            setInputValue(formatAadhar(value));
            setError('');
        }
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            setMobileNumber(value);
            setMobileError('');
        }
    };

    const handleOtpChange = (event, index) => {
        const { value } = event.target;
        if (/[^0-9]/.test(value)) return;

        const newValue = [...otpInput];
        newValue[index] = value;
        setOtpInput(newValue);

        if (value.length === 1 && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1].focus();
        } else if (value.length === 0 && index > 0) {
            inputRefs.current[index - 1].focus();
        }

        setOtpError('');
    };

    const handleAadharSubmit = async (e) => {
        e.preventDefault();
        const numericValue = inputValue.replace(/\s/g, '');

        if (!numericValue) {
            setError('Aadhar number is required.');
            return;
        }
        if (numericValue.length !== 12) {
            setError('Aadhar number must be exactly 12 digits.');
            return;
        }

        setError('');
        setLoading(true);
        try {
            const response = await axios.post(`${ABHA_API_URL}/abdm/m1/abha/send_otp`, {
                loginId: numericValue,
            });
            setTxnId(response.data.txnId);
            setStep('otp');
        } catch (error) {
            console.error('Error sending OTP:', error);
            setError(error.response?.data?.message || 'Failed to send OTP. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();

        if (mobileNumber.length !== 10) {
            setMobileError('Mobile number must be 10 digits');
            return;
        }

        if (otpInput.join('').length !== 6) {
            setOtpError('Please enter a valid 6-digit OTP');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${ABHA_API_URL}/abdm/m1/abha/verify_otp`, {
                txnId: txnId,
                mobileNo: mobileNumber,
                otp: otpInput.join(''),
            });

            if (response.status === 200 || response.status === 201) {
                const patientData = response.data.ABHAProfile;

                let base64String = '';
                if (response.data.imageBase64String) {
                    const base64Data = response.data.imageBase64String;
                    base64String = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
                }

                const patientRegistrationResponse = await axiosInstance.post('patient/newRegistration?pay=false', {
                    firstName: patientData.firstName || 'Test',
                    middleName: patientData.middleName || 'Test',
                    lastName: patientData.lastName || 'Test',
                    dob: patientData.dob || '22-01-1996',
                    gender: patientData.gender === 'M' ? 1 : patientData.gender === 'F' ? 2 : 3 || 1,
                    genderCode: patientData.gender || 'M',
                    contactNumber: patientData.mobile || '9876543211',
                    pinCode: patientData.pinCode || '363621',
                    address: patientData.address || 'Test, Test',
                    district: patientData.districtName || 'Test',
                    state: patientData.stateName || 'Gujarat',
                    city: patientData.city || 'Test',
                    nationality: 'India',
                    siteId: 2,
                    age: patientData.age || 31,
                    emailAddress: patientData.emailAddress || 'abc@gmail.com',
                    relation: patientData.relation || 2,
                    relationCode: patientData.relationCode || 'FTH',
                    prefixName: patientData.prefixName || 1,
                    prefix: patientData.prefix || '1',
                    agree: true,
                    receiveCall: true,
                    base64String: base64String || '',
                    siteCode: patientData.siteCode || 'SC01',
                    maritalStatus: patientData.maritalStatus || 1,
                    maritialStatusCode: patientData.maritialStatusCode || 'M',
                    emergencyContactNo: patientData.emergencyContactNo || '9876543212',
                    emergencyContactName: patientData.emergencyContactName || 'ABD',
                    addressList: [{
                        address: patientData.address || 'Test, Test',
                        postOffice: patientData.postOffice || 'Test',
                        streetvillage: patientData.village || 'Test',
                        policeStation: patientData.policeStation || 'Test',
                        city: 1,
                        district: patientData.districtName || 'Test',
                        postalCode: patientData.pinCode || '363622',
                    }]
                });

                if (patientRegistrationResponse.status === 200 || patientRegistrationResponse.status === 201) {
                    // const preparedDate = new Date().toLocaleString('en-GB').replace(',', '').replace(/ /g, '%20');
                    // window.open(`https://traumacentrebhu.com/live/birtreports?reportFormat=pdf&ReportName=Registration_Details_Print.rptdesign&patientId=${patientRegistrationResponse.data.patientId}&locale=en&reportLanguage=en&preparedId=45759&preparedDate=${preparedDate}&ServerPath=//traumacentrebhu.com%3A80/live/fos/%3Ftype%3D55`, '_blank');

                    // Pass only serializable data
                    navigate('/book-consultant', {
                        state: {
                            mrno: patientRegistrationResponse.data.mrno,
                            patientData: {
                                firstName: patientData.firstName || 'Test',
                                middleName: patientData.middleName || 'Test',
                                lastName: patientData.lastName || 'Test',
                                dob: patientData.dob || '22-01-1996',
                                gender: patientData.gender || 'M',
                                mobile: patientData.mobile || '9876543211',
                                emailAddress: patientData.emailAddress || 'abc@gmail.com',
                                pinCode: patientData.pinCode || '363621',
                                address: patientData.address || 'Test, Test',
                                districtName: patientData.districtName || 'Test',
                                stateName: patientData.stateName || 'Gujarat',
                                city: patientData.city || 'Test',
                            }
                        }
                    });
                } else {
                    setOtpError('Failed to register. Please try again.');
                }
            } else {
                setOtpError('Invalid OTP. Please try again.');
            }
        } catch (error) {
            console.error('Error verifying OTP:', error);
            setOtpError(error?.response?.data?.message || error?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleResendOTP = async () => {
        const numericValue = inputValue.replace(/\s/g, '');
        setLoading(true);
        try {
            const response = await axios.post(`${ABHA_API_URL}/abdm/m1/abha/send_otp`, {
                loginId: numericValue,
            });
            setTxnId(response.data.txnId);
            setSeconds(60);
            setIsResendEnabled(false);
            setOtpError('');
            setOtpInput(['', '', '', '', '', '']);
        } catch (error) {
            console.error('Error resending OTP:', error);
            setOtpError(error.response?.data?.message || 'Failed to resend OTP. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-6">
            <div className="flex items-center">
                <Link
                    to="/"
                    className="flex items-center w-28 px-4 py-3 bg-[#0FA968] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200"
                    style={{ fontFamily: 'Roboto', fontSize: '20px', fontWeight: '500', lineHeight: '23.44px' }}
                >
                    <img src={BackArrow} alt="Back" className="mr-2 w-6 h-6" />
                    Back
                </Link>
                <span
                    className="ml-4 text-2xl font-semibold"
                    style={{ fontFamily: 'Roboto', fontSize: '28px', fontWeight: '600', lineHeight: '32.81px' }}
                >
                    {step === 'aadhar' ? 'Already Registered' : 'New Registration'}
                </span>
            </div>

            <hr className="my-6 border-gray-300" />

            <div className="flex justify-center">
                <div className="bg-[#42424A] shadow-lg rounded-lg p-6 w-full max-w-md">
                    {step === 'aadhar' ? (
                        <form className="w-full" onSubmit={handleAadharSubmit}>
                            <div className="relative mt-10">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <img src={FiSearch} alt="Search Icon" className="w-5 h-5" />
                                </div>
                                <label htmlFor="aadhar" className="sr-only">Aadhar Number</label>
                                <input
                                    id="aadhar"
                                    type="text"
                                    value={inputValue}
                                    onChange={handleAadharChange}
                                    className={`bg-[#EFFEF7] border ${error ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-base rounded-lg block w-full pl-10 py-2 h-12 focus:outline-none focus:ring-2 ${error ? 'focus:ring-red-500' : 'focus:ring-gray-600'} focus:border-transparent`}
                                    placeholder="Enter Patient Aadhar Number"
                                    aria-invalid={error ? 'true' : 'false'}
                                    aria-describedby="aadhar-error"
                                    maxLength="14"
                                    disabled={loading}
                                />
                                {error && (
                                    <p id="aadhar-error" className="absolute text-red-500 text-sm mt-1" style={{ top: '100%' }}>
                                        {error}
                                    </p>
                                )}
                            </div>

                            <button
                                type="submit"
                                className="mt-10 mb-10 flex items-center justify-center w-20 px-4 py-3 bg-[#1ACD81] text-white font-semibold rounded-lg shadow hover:bg-[#138F5E] transition duration-200 mx-auto"
                                disabled={loading}
                            >
                                {loading ? (
                                    <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                                ) : (
                                    <img src={ForwadArrow} alt="Submit" className="w-6 h-6" />
                                )}
                            </button>
                        </form>
                    ) : (
                        <form className="w-full" onSubmit={handleOtpSubmit}>
                            <div className="relative mb-6">
                                <label
                                    className="block text-white mb-2"
                                    htmlFor="mobile"
                                    style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500' }}
                                >
                                    Enter Mobile Number
                                </label>
                                <input
                                    type="text"
                                    id="mobile"
                                    maxLength="10"
                                    value={mobileNumber}
                                    onChange={handleMobileChange}
                                    className={`bg-[#EFFEF7] border ${mobileError ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-lg rounded-lg block w-full h-12 px-4 focus:outline-none focus:ring-2 focus:ring-gray-600 focus:border-transparent`}
                                    placeholder="Enter 10-digit mobile number"
                                    aria-invalid={mobileError ? 'true' : 'false'}
                                    aria-describedby="mobile-error"
                                    disabled={loading}
                                />
                                {mobileError && (
                                    <p id="mobile-error" className="text-red-500 text-md mt-1">{mobileError}</p>
                                )}
                            </div>

                            <div className="relative mb-4 mt-6">
                                <label
                                    className="block text-white mb-2"
                                    htmlFor="otp-0"
                                    style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500' }}
                                >
                                    Enter OTP
                                </label>
                                <div className="flex justify-between items-center mb-4">
                                    <span
                                        className="text-white"
                                        style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '400' }}
                                    >
                                        An OTP has been sent to{' '}
                                        {mobileNumber ? `xxxxxx${mobileNumber.slice(6)}` : 'xxxxxx7272'}
                                    </span>
                                    {seconds > 0 && (
                                        <span
                                            className="text-[#1ACD81]"
                                            style={{ fontFamily: 'Roboto', fontSize: '14px', fontWeight: '400' }}
                                        >
                                            {seconds} sec
                                        </span>
                                    )}
                                </div>

                                <div className="flex flex-col">
                                    <div className="flex space-x-2">
                                        {otpInput.map((value, index) => (
                                            <div key={index} className="relative">
                                                <input
                                                    type="text"
                                                    maxLength="1"
                                                    id={`otp-${index}`}
                                                    ref={(el) => (inputRefs.current[index] = el)}
                                                    value={value}
                                                    onChange={(event) => handleOtpChange(event, index)}
                                                    className={`bg-[#EFFEF7] border ${otpError ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-lg rounded-lg block w-full h-12 text-center focus:outline-none focus:ring-2 focus:ring-gray-600 focus:border-transparent`}
                                                    placeholder=""
                                                    aria-label={`OTP digit ${index + 1}`}
                                                    aria-invalid={otpError ? 'true' : 'false'}
                                                    aria-describedby="otp-error"
                                                    disabled={loading}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    {otpError && (
                                        <p id="otp-error" className="text-red-500 text-md mt-1">
                                            {otpError}
                                        </p>
                                    )}
                                </div>

                                <div className="flex justify-between items-center mb-2 mt-4">
                                    <button
                                        type="button"
                                        className={`text-[#1ACD81] w-36 ${isResendEnabled && !loading ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                        style={{ fontFamily: 'Roboto', fontSize: '16px', fontWeight: '400' }}
                                        onClick={handleResendOTP}
                                        disabled={!isResendEnabled || loading}
                                    >
                                        Resend OTP
                                    </button>
                                    <button
                                        type="submit"
                                        className="bg-[#1ACD81] text-white w-full py-2 rounded-lg"
                                        style={{ fontFamily: 'Roboto', fontSize: '18px', fontWeight: '500' }}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
                                        ) : (
                                            'VERIFY'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}
                </div>
            </div>

            {step === 'aadhar' && (
                <div className="flex justify-end mt-6">
                    <Link
                        to="/patient-details"
                        className="text-[#565661] text-lg font-semibold flex items-center"
                    >
                        Continue Without Aadhar{' '}
                        <img src={FiChevronsRight} alt="Without Aadhar" className="ml-2" />
                    </Link>
                </div>
            )}
        </div>
    );
};

export default RegistrationWithAdhar;